import { createFileRoute } from "@tanstack/react-router";
import { MethodologyPage } from "../components/methodology-page";

/**
 * "How we work this out" — the page the carbon figure on a bag links to (US-35.1).
 *
 * <p>Outside `_authed` like the trace page it hangs off: the reader is a stranger holding a bag, and
 * the whole argument for publishing an estimate is that they can check the arithmetic without an
 * account.
 */
export const Route = createFileRoute("/methodology")({
  component: MethodologyPage,
});
